module.exports = __webpack_public_path__ + "img/noGood.7aec7edd.png";